import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import './index.css';
import Layout from './Layout';
import Dashboard from './Pages/Dashboard';
import Upload from './Pages/Upload';
import ApiTester from './Pages/ApiTester';
import UploadedFiles from './Pages/UploadedFiles';
import Operations from './Pages/Operations';
import GoogleSheetsQuestor from './Pages/GoogleSheetsQuestor';
import AnnualRevenue from './Pages/AnnualRevenue';
import UpdateAnnualRevenue from './Pages/UpdateAnnualRevenue';
import VariavelRevenue from './Pages/VariavelRevenue';
import Login from './Pages/Login';
import BensEmpresa from './Pages/BensEmpresa';
import BensVeiculos from './Pages/BensVeiculos';
import AgentIRPF from './Pages/AgentIRPF';
import AgentRendPF from './Pages/AgentRendPF';
import RendimentoPessoaFisica from './Pages/RendimentoPessoaFisica';
import ProLabore from './Pages/ProLabore';
import Extrato from './Pages/Extrato';
import CreditCard from './Pages/CreditCard';
import ContaReceitaZendry from './Pages/ContaReceitaZendry';
import DespesasGeralZendry from './Pages/DespesasGeralZendry';
import ContasaPagarZendry from './Pages/ContasaPagarZendry';
import C6Bank from './Pages/C6Bank';
import TovSolucoes from './Pages/TovSolucoes';
import BancoDoBrasilRJX from './Pages/BancoDoBrasilRJX';
import FibankRJX from './Pages/FibankRJX';
import ControleDePonto from './Pages/ControleDePonto';
import SoftBradesco from './Pages/SoftBradesco';
import SoftSantander from './Pages/SoftSantander';
import SoftUnicred from './Pages/SoftUnicred';
import { isAuthenticated } from './auth/simpleAuth';

// Componente para rotas protegidas
const ProtectedRoute = ({ children }) => {
  const authenticated = isAuthenticated();
  console.log('Verificando autenticação:', authenticated);
  
  if (!authenticated) {
    console.log('Usuário não autenticado, redirecionando para login');
    return <Navigate to="/login" replace />;
  }
  
  console.log('Usuário autenticado, renderizando componente');
  return children;
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        
        <Route path="/" element={
          <ProtectedRoute>
            <Layout>
              <Dashboard />
            </Layout>
          </ProtectedRoute>
        } />
        
        <Route path="/upload" element={
          <ProtectedRoute>
            <Layout>
              <Upload />
            </Layout>
          </ProtectedRoute>
        } />
        
        <Route path="/api-tester" element={
          <ProtectedRoute>
            <Layout>
              <ApiTester />
            </Layout>
          </ProtectedRoute>
        } />
        
        <Route path="/files" element={
          <ProtectedRoute>
            <Layout>
              <UploadedFiles />
            </Layout>
          </ProtectedRoute>
        } />
        
        <Route path="/operations" element={
          <ProtectedRoute>
            <Layout>
              <Operations />
            </Layout>
          </ProtectedRoute>
        } />
        
        <Route path="/google-sheets-questor" element={
          <ProtectedRoute>
            <Layout>
              <GoogleSheetsQuestor />
            </Layout>
          </ProtectedRoute>
        } />
        
        <Route path="/annual-revenue" element={
          <ProtectedRoute>
            <Layout>
              <AnnualRevenue />
            </Layout>
          </ProtectedRoute>
        } />
        
        <Route path="/update-annual-revenue" element={
          <ProtectedRoute>
            <Layout>
              <UpdateAnnualRevenue />
            </Layout>
          </ProtectedRoute>
        } />
        
        <Route path="/variavel-revenue" element={
          <ProtectedRoute>
            <Layout>
              <VariavelRevenue />
            </Layout>
          </ProtectedRoute>
        } />
        
        <Route path="/bens-empresa" element={
          <ProtectedRoute>
            <Layout>
              <BensEmpresa />
            </Layout>
          </ProtectedRoute>
        } />
        
        <Route path="/bens-veiculos" element={
          <ProtectedRoute>
            <Layout>
              <BensVeiculos />
            </Layout>
          </ProtectedRoute>
        } />
        
        <Route path="/agent-irpf" element={
          <ProtectedRoute>
            <Layout>
              <AgentIRPF />
            </Layout>
          </ProtectedRoute>
        } />
        
        <Route path="/rendimento-pessoa-fisica" element={
          <ProtectedRoute>
            <Layout>
              <RendimentoPessoaFisica />
            </Layout>
          </ProtectedRoute>
        } />
        
        <Route path="/extrato" element={
          <ProtectedRoute>
            <Layout>
              <Extrato />
            </Layout>
          </ProtectedRoute>
        } />

        <Route path="/pro-labore" element={
          <ProtectedRoute>
            <Layout>
              <ProLabore />
            </Layout>
          </ProtectedRoute>
        } />
        
        <Route path="/agent-rendpf" element={
          <ProtectedRoute>
            <Layout>
              <AgentRendPF />
            </Layout>
          </ProtectedRoute>
        } />
        
        <Route path="/credit-card" element={
          <ProtectedRoute>
            <Layout>
              <CreditCard />
            </Layout>
          </ProtectedRoute>
        } />
        
        <Route path="/conta-receita-zendry" element={
          <ProtectedRoute>
            <Layout>
              <ContaReceitaZendry />
            </Layout>
          </ProtectedRoute>
        } />
        
        <Route path="/despesas-geral-zendry" element={
          <ProtectedRoute>
            <Layout>
              <DespesasGeralZendry />
            </Layout>
          </ProtectedRoute>
        } />
        
        <Route path="/contas-a-pagar-zendry" element={
          <ProtectedRoute>
            <Layout>
              <ContasaPagarZendry />
            </Layout>
          </ProtectedRoute>
        } />
        
        <Route path="/c6-bank" element={
          <ProtectedRoute>
            <Layout>
              <C6Bank />
            </Layout>
          </ProtectedRoute>
        } />
        
        <Route path="/tov-solucoes" element={
          <ProtectedRoute>
            <Layout>
              <TovSolucoes />
            </Layout>
          </ProtectedRoute>
        } />
        
        <Route path="/banco-do-brasil-rjx" element={
          <ProtectedRoute>
            <Layout>
              <BancoDoBrasilRJX />
            </Layout>
          </ProtectedRoute>
        } />
        
        <Route path="/fibank-rjx" element={
          <ProtectedRoute>
            <Layout>
              <FibankRJX />
            </Layout>
          </ProtectedRoute>
        } />
        
        <Route path="/controle-ponto" element={
          <ProtectedRoute>
            <Layout>
              <ControleDePonto />
            </Layout>
          </ProtectedRoute>
        } />
        
        <Route path="/soft-bradesco" element={
          <ProtectedRoute>
            <Layout>
              <SoftBradesco />
            </Layout>
          </ProtectedRoute>
        } />
        
        <Route path="/soft-santander" element={
          <ProtectedRoute>
            <Layout>
              <SoftSantander />
            </Layout>
          </ProtectedRoute>
        } />
        
        <Route path="/soft-unicred" element={
          <ProtectedRoute>
            <Layout>
              <SoftUnicred />
            </Layout>
          </ProtectedRoute>
        } />
        
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);
